export default __webpack_public_path__ + "static/media/logo.3d6542c1.jpeg";